import Link from 'next/link';
import BackButton from '@/components/customercenter-ui/components/ui/back-button';
import LockIcon from '@/components/customercenter-ui/icons/lock-icon';
import { GlobalPageTexts } from '@/helpers/i18n';
import { TranslateText } from '@/helpers/utils/siteUtils';
import { DEFAULT_SITE_LANG } from '../../../../../constants/constant';

const Header = () => {
  const Texts = TranslateText(GlobalPageTexts, DEFAULT_SITE_LANG);

  return (
    <header className="items-center justify-between lg:flex">
      <section className="flex justify-center gap-x-2 pt-8 lg:items-center lg:py-10">
        <Link className="h-7 w-5 text-left" href="/" aria-label="Secure Checkout">
          <LockIcon className="h-full w-full fill-black" />
        </Link>
        <Link className="text-2xl font-bold leading-8 lg:mt-1" href="/">
          {Texts?.secureCheckout}
        </Link>
      </section>
      {/* <section className="flex items-center justify-center gap-x-2 pb-9 pt-5 lg:py-10">
        <Link className="h-6 w-6" href="/cart" aria-label="Return to Cart">
          <ShoppingCartIcon className="h-full w-full" />
        </Link>
        <Link className="text-base font-normal leading-5 underline" href="/cart">
          {Texts?.returnToCart}
        </Link>
      </section> */}
      <BackButton text={Texts.backToCatalog} className={`flex text-blueLight underline`} url={'/search/?q='} />
    </header>
  );
};

export default Header;
